import { ReduxStore } from "../../reducers/root_reducer";

const getDomain = (state: ReduxStore, props) => state.domain;

export default getDomain;
